import cookieConsent from './cookieConsent';
import videolink from './videolink';

document.addEventListener('DOMContentLoaded', () => {
    cookieConsent();
    videolink();
});
